import { render, staticRenderFns } from "./sortGrid.vue?vue&type=template&id=33ae7b21&scoped=true&"
import script from "./sortGrid.vue?vue&type=script&lang=js&"
export * from "./sortGrid.vue?vue&type=script&lang=js&"
import style0 from "./sortGrid.vue?vue&type=style&index=0&id=33ae7b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ae7b21",
  null
  
)

export default component.exports